import { BUSINESS_TYPES } from "./classifyBusiness";

// How each business type is named on screen (always "classified as ...").
export const BUSINESS_TYPE_LABELS = {
  local: "Local business",
  national: "National",
  franchise: "Franchise",
  directory: "Directory",
  lead_gen: "Lead generation",
  unclassified: "Unclassified",
};

// Why an advertiser has its type.
export const BASIS_LABELS = {
  manual: "your correction",
  list: "on AdAudit's list",
  rule: "has a Google Maps listing",
  none: "no rule matched",
};

// The Business type filter: tick boxes, nothing ticked = all types, plus a
// one-click "All except directories" shortcut.
export const NOT_DIRECTORY_TYPES = BUSINESS_TYPES.filter(t => t !== "directory");
export const BUSINESS_TYPE_SHORTCUTS = [{ label: "All except directories", values: NOT_DIRECTORY_TYPES }];

// The filter's values from a page address. Old addresses had one choice
// (?type=all, ?type=not_directory, ?type=local); new ones list the types
// (?type=local&type=national). Unknown values are dropped; the types come
// back in the usual order, and every type ticked counts as all ([]).
export function businessTypesFromAddress(values) {
  const wanted = new Set();
  for (const v of values || []) {
    if (v === "not_directory") NOT_DIRECTORY_TYPES.forEach(t => wanted.add(t));
    else if (BUSINESS_TYPES.includes(v)) wanted.add(v);
  }
  const types = BUSINESS_TYPES.filter(t => wanted.has(t));
  return types.length === BUSINESS_TYPES.length ? [] : types;
}
